module.exports = __webpack_public_path__ + "static/media/thought-background-1.1fbcc1dd.svg";